import { Box, Grid2, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import SearchBar from '../../shared/components/SearchBar'
import CustomDivider from '../../shared/utils/CustomDivider'
import { useDialog } from '../../shared/hook/useDialog'
import MainDialogBox from '../../shared/components/Dialog/DialogMainBox'
import { LightButton } from '../../shared/utils/CustomButton'
import FilterListIcon from '@mui/icons-material/FilterList';
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { AutoCompleteField } from '../../shared/components/FormFields/AutoCompleteField'
import { DateFormField } from '../../shared/components/FormFields/DataFormField'
import DialogFooter from '../../shared/components/Dialog/DialogFooter'
import CustomSlider from '../../shared/components/FormFields/CustomSlider'
import { Page_Padding } from '../../shared/constants'
import LatestEventCard from '../../shared/components/LatestEventCard'
import { useEventCategory, useEventFilter, useEvents, useVenueCityList } from '../../assets/api/useGetApi'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import useResponsive from '../../shared/utils/Responsive'
import { FormAutoComplete } from '../../shared/components/FormFields/FormAutoComplete'
import { getGridSize } from '../../shared/formatter'


const Events = () => {
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: events, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } = useEvents();
    const { data: eventscategory, isLoading: categoryIsLoading } = useEventCategory();
    const allEvent = events?.pages.flatMap(page => page.data) || [];
    const CategoryOptions = eventscategory?.data?.map((category) => ({
        id: category?.id,
        label: category?.name,
        value: category?.name,
    })) || []

    const { data: venueCityList, isLoading: venueCityIsLoading } = useVenueCityList();
    const EventCityOptions = venueCityList?.event_cities?.map((item) => ({
        label: item?.event_city,
        value: item?.event_city,
    })) || [];

    const EventVenueOptions = venueCityList?.event_venues?.map((item) => ({
        label: item?.event_venue,
        value: item?.event_venue,
    })) || [];
    const isSmallScreen = useResponsive("sm")
    const [filters, setFilters] = useState({});
    const { data: filterEvent, isLoading: filterIsLoading } = useEventFilter(filters);
    const observerRef = useRef(null);
    useEffect(() => {
        if (!observerRef.current) return;
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
                    fetchNextPage();
                }
            },
            { threshold: 1 }
        );
        observer.observe(observerRef.current);
        return () => observer.disconnect();
    }, [fetchNextPage, hasNextPage, isFetchingNextPage, observerRef]);
    const initialValues = {
        start_date: "",
        end_date: "",
        event_category: "",
        price: "",
    };

    const validationSchema = Yup.object().shape({
    });

    const handleSubmit = (values, { resetForm }) => {
        const obj = {
            start_date: values.start_date,
            end_date: values.end_date,
            event_category_id: values.event_category,
            event_venue: values.event_venues,
            event_city: values.event_cities,
            min_price: values.price[0],
            max_price: values.price[1]
        }

        const filteredValues = Object.fromEntries(
            Object.entries(obj).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
        );
        setFilters(filteredValues);
        handleClose();
        resetForm()
    };
    return (
        <Box className="body event_course" px={Page_Padding}>
            <SearchBar />
            <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} />
            <Box textAlign={"end"}>
                <LightButton onClick={handleClickOpen} text={"Filter"} icon={<FilterListIcon sx={{ color: "#000000", fontSize: "24px" }} />} />
            </Box>
            <CustomDivider orientation="horizontal" size={isSmallScreen ? "20px" : undefined} />
            <Grid2 container spacing={5} sx={{ display: 'flex', justifyContent: "center" }}>
                {(isLoading && filterIsLoading) ? (
                    [...Array(9)].map((_, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <SkeletonCom />
                        </Grid2>
                    ))
                ) : filterEvent?.data?.length > 0 ? (
                    filterEvent?.data.map((item, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: getGridSize(filterEvent?.data?.length) }} key={index}
                            display={"flex"} alignItems={"stretch"}
                        >
                            <LatestEventCard item={item} />
                        </Grid2>
                    ))
                ) : filterEvent?.data?.length === 0 ? (
                    <Box textAlign="center" width="100%">
                        <Typography variant='h6'>Events not found</Typography>
                    </Box>
                ) : (
                    allEvent.map((item, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: getGridSize(allEvent?.length) }} key={index}
                            display={"flex"} alignItems={"stretch"}
                        >
                            <LatestEventCard item={item} />
                        </Grid2>
                    ))
                )}
            </Grid2>

            {isFetchingNextPage && (
                <Grid2 container spacing={5} sx={{ display: "flex", justifyContent: "center" }}>
                    {[...Array(3)].map((_, index) => (
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                            <SkeletonCom />
                        </Grid2>
                    ))}
                </Grid2>
            )}

            <div ref={observerRef} style={{ height: "20px", marginBottom: "10px" }} />

            <MainDialogBox open={open} handleClose={handleClose} width={"30%"} heading={"Filter"}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {({ values }) => (
                        <Form>
                            <Grid2 container spacing={"30px"}>
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="start_date"
                                        component={DateFormField}
                                        label="From Date"
                                        maxDate={values.end_date || undefined}
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={{ xs: 12, sm: 6 }}>
                                    <Field
                                        name="end_date"
                                        component={DateFormField}
                                        label="To Date"
                                        minDate={values.start_date || undefined}
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="event_category"
                                        component={AutoCompleteField}
                                        options={CategoryOptions}
                                        label="Course Category"
                                        isRequired={true}
                                        isLoading={categoryIsLoading}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="event_cities"
                                        component={FormAutoComplete}
                                        options={EventCityOptions}
                                        label="City"
                                        isRequired={true}
                                        isLoading={venueCityIsLoading }

                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="event_venues"
                                        component={FormAutoComplete}
                                        options={EventVenueOptions}
                                        label="Venue"
                                        isRequired={true}
                                        isLoading={venueCityIsLoading}
                                    />
                                </Grid2>
                                {/*     <Grid2 children size={12}>
                                    <Field
                                        name="price"
                                        component={AutoCompleteField}
                                        options={cityOptions}
                                        label="Price"
                                        isRequired={true}
                                    />
                                </Grid2> */}
                                <Grid2 children size={12}>
                                    <Field
                                        name="price"
                                        component={CustomSlider}
                                        label="Price"
                                        initialValue={1000}
                                        finalValue={3000}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <DialogFooter handleClose={handleClose} buttonName={"Filter"} />
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </MainDialogBox>
        </Box>
    )
}

export default Events